import { makeStyles } from '@material-ui/core/styles'
import { CALLOUT_BACKGROUND, CALLOUT_FOREGROUND } from 'lib/form-field-styles'

export const useStyles = makeStyles(theme => ({
  embeddedRoot: {
    width: '100%',
  },
  titleFont: {
    fontSize: '16px',
    color: theme.palette.text.secondary,
    fontWeight: 900,
  },
  headerFont: {
    fontSize: '30px',
    fontWeight: 900,
  },
  avatarWrapper: {
    marginRight: '15px',
  },
  studentContent: {
    margin: '15px 0',
  },
  exportButton: {
    marginLeft: theme.spacing(1),
    textTransform: 'none',
    fontWeight: 600,
  },
  exportMenuItem: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4, 2, 6),
    textAlign: 'center',
    gap: theme.spacing(2),
  },
  emptyStateTitle: {
    fontWeight: 600,
    marginTop: theme.spacing(1),
  },
  emptyStateCaption: {
    color: theme.palette.text.secondary,
    maxWidth: 360,
    marginBottom: theme.spacing(1),
  },
  emptyStateActions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  headerActionButton: {
    textTransform: 'none',
    fontWeight: 600,
  },
  tonalButton: {
    color: CALLOUT_FOREGROUND,
    backgroundColor: CALLOUT_BACKGROUND,
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: CALLOUT_BACKGROUND,
      boxShadow: 'none',
    },
  },
}))
